import { render } from "./EditRecordType.vue?vue&type=template&id=78ee7897&scoped=true"
import script from "./EditRecordType.vue?vue&type=script&lang=js"
export * from "./EditRecordType.vue?vue&type=script&lang=js"

import "./EditRecordType.vue?vue&type=style&index=0&id=78ee7897&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ee7897"]])

export default __exports__